import {IPNSOrganizationType} from '@portal-ng/PNSModels/PNSOrganizationType.enum';
import {IPNSSearch} from '@portal-ng/PNSModels/PNSSearch.model';

export interface IPNSOrganizationSearch extends IPNSSearch {
  type?: IPNSOrganizationType | null;
}
